import { getInvoicingInfo } from '@/redux/api/analytics-api'
import { useEcommerceId } from './use-ecommerce-id'
import { useQuery } from '@tanstack/react-query'

export function useInvoicingInfo() {
  const ecommerceId = useEcommerceId()

  const invoicingInfoQuery = useQuery({
    queryKey: ['invoicingInfo', ecommerceId],
    queryFn: () => getInvoicingInfo(ecommerceId ?? ''),
    enabled: ecommerceId !== undefined,
    staleTime: 1000 * 60 * 10
  })

  const invoicingData = invoicingInfoQuery.data

  return { invoicingData }
}
